import { AlertCircle, Inbox } from "lucide-react";

export function LoadingState() {
  return <div className="loading-state"><span className="spinner" />Carregando</div>;
}

export function ErrorState({ message }: { message: string }) {
  return <div className="notice notice-error"><AlertCircle size={18} />{message}</div>;
}

export function EmptyState({ label }: { label: string }) {
  return <div className="empty-state"><Inbox size={24} /><span>{label}</span></div>;
}

export function Status({ active }: { active: boolean }) {
  return <span className={`status ${active ? "status-active" : "status-inactive"}`}>{active ? "Ativo" : "Inativo"}</span>;
}
